import DbBackupsEdit from './DbBackupsEdit';
import WebUniversal, { WUExtendPropsType } from '../WebUniversalNewExExEx'
import { columnsheadId } from '../../universal/columnshead';
import { useEffect, useRef, useState } from 'react';
import { Button, Popover, Space } from 'antd';
import DbTables from './DbTables';
import fetchApi from '../../../utils/api/fetchApi';
import AntdNotification from '../../../utils/extend/AntdNotification';

const DbBackups = (props: any) => {
    /** api服务id */
    const apiId = 'dbBackups';
    const ref = useRef<any>(undefined);

    const [modalVisibleDbTables, setModalVisibleDbTables] = useState(false);
    const [dbBackupsId, setDbBackupsId] = useState<string>();
    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    /** 刷新 */
    const [InitData, setInitData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setInitData(() => ref.current.initData);
        }
        // const res = await fetchApi.GET(urlService,
        //     {
        //         apiId: 'configs',
        //         apiVariable: 'system',
        //         apiExtend: 'getNodeValue',
        //         apiData: {
        //             nodeId: 'companyFilePath',
        //             privatePar: false
        //         }
        //     });
    }, []);
    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'backupName',
        },
        {
            title: '数据库',
            dataIndex: 'dbSystem_Name',
        },
        {
            title: '数据表',
            dataIndex: 'id',
            sorter: true,
            render: (text: any, record: any) => (
                <Button type='primary' onClick={() => {
                    setDbBackupsId(text);
                    setModalVisibleDbTables(true);
                }}>{'数据表'}</Button>
            )
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string) => {
                return (
                    <Popover
                        title="是否执行？"
                        trigger="click"
                        content={(<Space>
                            <Button onClick={() => setActivePopoverId(null)}>否</Button>
                            <Button type='primary' onClick={() => {
                                fetchApi.PUT(defaultService,
                                    {
                                        apiId: 'dbBackups',
                                        apiExtend: 'execute',
                                        apiData: {
                                            dbBackupsId: id
                                        }
                                    }).then(res => {
                                        console.log(res);

                                        if (res?.success === true) {
                                            AntdNotification('success', '执行成功');
                                            InitData();
                                        } else {
                                            AntdNotification('error', res?.message);
                                        }
                                    });
                                setActivePopoverId(null);
                            }}>是</Button>
                        </Space>)}
                        open={activePopoverId === id}
                        onOpenChange={(visible) => {
                            setActivePopoverId(visible ? id : null);
                        }}
                    >
                        <Button type="default">执行</Button>
                    </Popover>
                )
            }
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '数据库备份',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent: DbBackupsEdit,
        showLogger: {
            loggerDisplay: true,
            loggerSingleDisplay: true,
            logType: {
                id: 'SYSTEM',
                name: '数据库备份日志'
            },
            loggerQueryType: 'dbBackups'
        }
    };

    return (
        <>
            <WebUniversal props={extendProps} ref={ref} />
            {modalVisibleDbTables ? (<DbTables closeModal={() => setModalVisibleDbTables(false)} data={{ dbBackupsId }} />) : null}
        </>
    )
}

export default DbBackups;
